module.exports = __webpack_public_path__ + "img/javi.be960181.jpg";